import {
  RESET_CHANGE_STATUS,
  CHANGE_STATUS_NOT_FOUND,
  CHANGE_STATUS_FAILED,
  CHANGE_STATUS_INVALID_REQUEST,
  CHANGE_STATUS_SUCCESS,
  LOADING_CHANGE_STATUS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CHANGE_STATUS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case CHANGE_STATUS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
        status: "Order status change failed!",
      };

    case CHANGE_STATUS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
        status: "Oops!! something went wrong",
      };

    case CHANGE_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        status: "Status changed successfully",
      };

    case CHANGE_STATUS_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
        status: "Not found",
      };

    case RESET_CHANGE_STATUS:
      return (state = initialState);

    default:
      return state;
  }
};
